import {fromPairs, map, sortBy} from 'lodash';
import iso3166 from 'iso-3166-2';

export default function getRegionsMap(countryCodeOrName: string) {
	return fromPairs(sortBy(map(
		iso3166.country(countryCodeOrName)?.sub,
		(value, key) => [key.split('-')[1], value.name],
	), 1));
}